import React from 'react';
import GroupsIcon from '@mui/icons-material/Groups';
import { heritageColors } from '../../../../heritageTheme.ts';

/**
 * Compact – תבנית קומפקטית אנכית
 * כל איש קשר בשורה אחת צפופה – מתאימה למידות קטנות וצרות
 */
const Compact = ({ initialData = { contacts: [] }, title = 'אנשי קשר והנהלה', showTitle = true }) => {
  const contacts = initialData.contacts || [];

  return (
    <div style={{
      padding: '0.75em',
      direction: 'rtl',
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      fontSize: 'inherit',
    }}>
      {showTitle && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.4em',
          paddingBottom: '0.5em',
          marginBottom: '0.5em',
          borderBottom: `0.03125em solid ${heritageColors.border}`,
        }}>
          <GroupsIcon sx={{ color: heritageColors.navy, fontSize: '1.1em' }} />
          <h3 style={{
            margin: 0,
            fontWeight: 'bold',
            color: heritageColors.navy,
            fontSize: '0.8125em',
          }}>{title}</h3>
        </div>
      )}

      {contacts.length === 0 ? (
        <div style={{ color: heritageColors.slate, fontSize: '0.8125em', textAlign: 'center' }}>
          אין אנשי קשר להצגה
        </div>
      ) : (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '0.25em',
          flex: 1,
          overflow: 'auto',
        }}>
          {contacts.map((contact, index) => (
            <div
              key={contact.id || index}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.5em',
                padding: '0.375em 0.5em',
                borderRadius: '0.25em',
                backgroundColor: index % 2 === 0 ? 'transparent' : heritageColors.cream,
                borderRight: `0.1875em solid ${heritageColors.gold}`,
              }}
            >
              <span style={{
                color: heritageColors.navy,
                fontWeight: 'bold',
                fontSize: '0.8125em',
                minWidth: '4em',
              }}>
                {contact.name}
              </span>

              <span style={{
                color: heritageColors.teal,
                fontSize: '0.6875em',
                flex: 1,
              }}>
                {contact.role}
              </span>

              {contact.phone && (
                <span style={{
                  color: heritageColors.slate,
                  fontSize: '0.75em',
                  direction: 'ltr',
                  letterSpacing: '0.03125em',
                }}>
                  {contact.phone}
                </span>
              )}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Compact;
